import { hashHistory } from 'react-router'
import fetchDisclosureDataFromServer from "./fetchDisclosureDataFromServer";
import {ERRORS} from "./fetchDisclosureDataFromServer";

export const REQUEST_HISTORY = "REQUEST_HISTORY";
export const RECEIVE_HISTORY = "RECEIVE_HISTORY";
export const RECEIVE_AUTHOR = "RECEIVE_AUTHOR";
export const RECEIVE_CHANGE_HISTORY = "RECEIVE_CHANGE_HISTORY";
export const RECEIVE_LAST_DIFFERING = "RECEIVE_LAST_DIFFERING";
export const DISCLOSURE_FETCH_ERROR = "DISCLOSURE_FETCH_ERROR";

export const requestHistory = () => ({
    type: REQUEST_HISTORY,
    payload: null
});

export const receiveHistory = (data) => ({
    type: RECEIVE_HISTORY,
    payload: data
});

export const receiveAuthor = (data) => ({
    type: RECEIVE_AUTHOR,
    payload: data
});

export const receiveChangeHistory = (data) => ({
    type: RECEIVE_CHANGE_HISTORY,
    payload: data
});

export const receiveLastDiffering = (data) => ({
    type: RECEIVE_LAST_DIFFERING,
    payload: data
});

export const disclosureFetchError = (errorType) => ({
    type: DISCLOSURE_FETCH_ERROR,
    payload: errorType,
    error: true
});

export function loadHistory(recommendationId, fetchDisclosureData = fetchDisclosureDataFromServer) {
    return (dispatch) => {
        dispatch(requestHistory());

        fetchDisclosureData(recommendationId,
            response => {
                if (response.error === ERRORS.UNAUTHENTICATED) {
                    hashHistory.push("/verify-email");
                }

                if (response.error !== null) {
                    dispatch(disclosureFetchError(response.error));
                }

                if (response.success !== null) {
                    const data = response.success;
                    dispatch(receiveHistory(data.history));
                    dispatch(receiveAuthor(data.author));
                    dispatch(receiveChangeHistory(data.changeHistory));
                    dispatch(receiveLastDiffering(data.lastDiffering));
                }
            }
        );
    }
}





/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/actions/historyActions.js
 **/